import {createContext} from "react";
import {DIRECTORY_DATA} from "./directoryData";

export const DirectoryContext = createContext(DIRECTORY_DATA)
